import React, {useEffect} from "react";

import { FavIcon } from "~/assets/svg/MathIcon";
import darkNewImg from "~/common/components/Images";
import lightProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import { useTranslation } from "react-i18next";
import { TRANS_INDUSTRY_CATEGORY_LIST, INVEST_LEVEL } from "~/constant/ApplyFormConstant";
import { useGlobalStore } from "~/store";
import useAlert from "~/common/hooks/useAlert";
import { BTN_STATUS, BTN_TEXT, TRANS_STATUS } from "~/constant/ApplyManageConstant";

const ApplyMangeListTable = ({
	getDetailModal,
	applyList,
	deleteApply,
	currentTab,
	totalCount,
	formData,
}) => {
	const { t } = useTranslation();
	const [
		{
			theme: { theme },
			sidebar: { currentPath },
		},
	] = useGlobalStore();

	const [showAuthAlert, AuthAlert] = useAlert();

	// 산업 분야
	const translateIndustryField = (item) => {
		let fieldList = [];
		item.split(",").map((field) =>
			fieldList.push(TRANS_INDUSTRY_CATEGORY_LIST[field] || field)
		);
		return fieldList.join();
	};

	const currentApplyList =
		applyList?.filter(
			(apply) => apply.status?.replace(" ", "") === currentTab || currentTab === "전체"
		) || [];

	const getBtnList = (item, idx) => {
		return (
			<button
				type="button"
				className="btn__outline angled"
				color="primary"
				onClick={() => {
					if (currentPath.auth !== "edit") {
						showAuthAlert();
						return;
					}
					item === "delete" ? deleteApply(idx) : getDetailModal(idx, item);
				}}
			>
				{BTN_TEXT[item]}
			</button>
		);
	};

	return (
		<>
			{currentApplyList.map((item, index) => {
				return (
					<li className="apply-management-item" key={index}>
						<div className="management-item-left">
							<p className="apply-evaluate-date">
								{totalCount - (formData.size * (formData.page - 1) + index)}
							</p>
							<div className="apply-company-data">
								<div className="data-wrap">
									<p className="apply-company-name">{item.startup.name}</p>
									<div className="apply-company-info">
										{item.startup.ceo && <span>{item.startup.ceo}</span>}
										<span>
											{item.startup.investLevel &&
												(INVEST_LEVEL.find(
													(value) =>
														value.value === item.startup.investLevel
												)?.label ??
													"-")}
										</span>
										{item.startup.establishedAt && (
											<span>
												{new Date().getFullYear() -
													parseInt(
														item.startup.establishedAt.substring(0, 4)
													) +
													1}
												{t(
													"pages.apply.ApplyEval.ApplyEvalPopup.yearStandard"
												)}
											</span>
										)}
										{item.startup.industryField && (
											<span>
												{translateIndustryField(item.startup.industryField)}
											</span>
										)}
									</div>
								</div>
								<div className="management-btn-group">
									{BTN_STATUS[item.status].map((btn) =>
										getBtnList(btn, item.idx)
									)}
								</div>
							</div>
						</div>

						{item.judges.length === 0 ? (
							<div className="management-item-right">
								<div className="judge-list waiting">
									-
									{/*{t("pages.apply.ApplySetting.ProcessingModal.Three.waiting")}*/}
								</div>
								<p className="apply-evaluate-state">{TRANS_STATUS[item.status]}</p>
							</div>
						) : (
							<div className="management-item-right">
								<div className="judge-list">
									<div className="c__dropdown-wrap">
										<button className="btn-dropdown visible">
											{
												(item.judges?.length > 0) &&
												<ul className="logo-group" onClick={() => getDetailModal(item.idx, "participantJudge", item?.judges ?? [])}>
													{item.judges.map((jList, idx) => {
														if (idx < 2) {
															return (
																<li className="judge-item" key={idx}>
																	<div className="img-wrap">
																		<img
																			src={
																				jList.user.img ||
																				(theme === "dark"
																					? darkNewImg
																					: lightProfileImg)
																			}
																			alt="심사역이미지"
																		/>
																	</div>
																	<span>{jList.user.name}</span>
																</li>
															);
														}
													})}
													{
														(item.judges?.length > 2) && <li className="judge-item etc"><span>...</span></li>
													}
												</ul>
											}


										</button>
										<div className={`c__dropdown`}>
											{/* <div className={`c__dropdown visible`}> */}
											<p className="dropdown-title">
												{t(
													"pages.apply.ApplyManage.applyMangeListTable.judge"
												)}
												<span>4</span>
											</p>
											<ul className="detail-list">
												<li className="c__dropdownItem">
													<div className="img-wrap">
														<img
															src={
																theme === "dark"
																	? darkNewImg
																	: lightProfileImg
															}
															alt={t(
																"pages.apply.ApplyManage.applyMangeListTable.judgeImage"
															)}
														/>
													</div>
													<dl>
														<dt>
															{t(
																"pages.apply.ApplyManage.applyMangeListTable.initName"
															)}
														</dt>
													</dl>
												</li>
												<li className="c__dropdownItem">
													<div className="img-wrap">
														<img
															src={
																theme === "dark"
																	? darkNewImg
																	: lightProfileImg
															}
															alt={t(
																"pages.apply.ApplyManage.applyMangeListTable.judgeImage"
															)}
														/>
													</div>
													<dl>
														<dt>
															{t(
																"pages.apply.ApplyManage.applyMangeListTable.initName"
															)}
														</dt>
													</dl>
												</li>
												<li className="c__dropdownItem">
													<div className="img-wrap">
														<img
															src={
																theme === "dark"
																	? darkNewImg
																	: lightProfileImg
															}
															alt={t(
																"pages.apply.ApplyManage.applyMangeListTable.judgeImage"
															)}
														/>
													</div>
													<dl>
														<dt>
															{t(
																"pages.apply.ApplyManage.applyMangeListTable.initName"
															)}
														</dt>
													</dl>
												</li>
												<li className="c__dropdownItem">
													<div className="img-wrap">
														<img
															src={
																theme === "dark"
																	? darkNewImg
																	: lightProfileImg
															}
															alt={t(
																"pages.apply.ApplyManage.applyMangeListTable.judgeImage"
															)}
														/>
													</div>
													<dl>
														<dt>
															{t(
																"pages.apply.ApplyManage.applyMangeListTable.initName"
															)}
														</dt>
													</dl>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<p
									className={
										item.status === "심사중"
											? "apply-evaluate-state ongoing"
											: "apply-evaluate-state"
									}
								>
									{TRANS_STATUS[item.status]}
								</p>
							</div>
						)}
					</li>
				);
			})}
			<AuthAlert
				message={
					<>
						권한이 없습니다. <br />
						관리자에게 문의하세요.
					</>
				}
				type="warning"
				confirm="확인"
			/>
		</>
	);
};

export default ApplyMangeListTable;
